var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3014_19911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94904 3.212V4.65232M3.94904 6.09265C2.51719 6.09265 1.35645 4.93191 1.35645 3.50006C1.35645 2.06821 2.51719 0.907471 3.94904 0.907471C5.38088 0.907471 6.54163 2.06821 6.54163 3.50006C6.54163 4.93191 5.38088 6.09265 3.94904 6.09265ZM3.96338 2.3478V2.37661L3.93469 2.37666V2.3478H3.96338Z",
    stroke: "#647184",
    strokeWidth: 0.496437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3014_19911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.91357,
    height: 6.91357,
    fill: "white",
    transform: "translate(0.492188 0.0432129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.7de10f68a0bc1ee42a3e5527ba04d94c.svg";
export { ForwardRef as ReactComponent };